import { Box, BoxProps, Center, HStack, Text, useColorModeValue } from "@chakra-ui/react";
import Icon from "components/Icon/Icon";
import CloseWindow from "components/Pay/CloseWindow";
import ls from "utils/secureStorage";
import configs from "config";

export interface PoweredByProps extends BoxProps {
  closeWindow?: boolean;
}

export function PoweredBy(props: PoweredByProps) {
  const logoColor = useColorModeValue("primary.default", "secondary.400");

  const accessKey = ls.get(configs.ACCESS_KEY);
  const ref = `?srcMode=bitwaya&srcRef=${window.location.hostname}&accessKey=${accessKey}`;

  return (
    <Box pos="absolute" bottom={{ base: "1.5%", md: "25px" }} left="50%" transform="translate(-50%, 0%)" {...props}>
      {props.closeWindow && (
        <Center>
          <CloseWindow mt="0 !important" />
        </Center>
      )}

      <a href={`https://bitmama.io/${ref}`} target="_blank" rel="noreferrer">
        <HStack alignItems="baseline" whiteSpace="nowrap" transition="width 500ms cubic-bezier(0.35, 0.04, 0, 0.98)">
          <Icon type="lockCircle" pos="relative" bottom="-6px" right="-6px" />
          <Text fontSize="xs" fontWeight="500">
            Powered by
          </Text>
          <Text ml="2px !important" fontWeight="600" fontSize="md" fontFamily="var(--bitmama-fonts-heading)" color={logoColor}>
            Bitmama
          </Text>
        </HStack>
      </a>
    </Box>
  );
}
